import { createAsyncThunk } from "@reduxjs/toolkit";

import { instance } from "../../axios/axios";

export const updateSalesTags = createAsyncThunk(
  "sales/update-tags",
  async ({ updatedtagsData }, { rejectWithValue, getState }) => {
    console.log(updatedtagsData);
    try {
      const state = getState();
      const token = state.auth?.token;

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.post(
        `/sales/portal/update-tags/${updatedtagsData?.salesRecordingId}`,
        updatedtagsData,
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const teamLeaderRequestForm = createAsyncThunk(
  "teamLeader/request",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await instance.post(
        "/sales/portal/team-leader-request",
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const uploadCritique = createAsyncThunk(
  "sales/upload-critique",
  async (payload, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${payload.token}`,
        },
      };

      const { data } = await instance.post(
        "/sales/portal/upload-critique",
        {
          recID: payload.recID,
          fileUrl: payload.fileUrl,
          fileName: payload.fileName,
          critiqueNotes: payload.critiqueNotes,
          avgDailyRevenue: payload.avgDailyRevenue,
          typeOfRequest: payload.typeOfRequest,
          salesRecordingId: payload.salesRecordingId,
        },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const uploadRecording = createAsyncThunk(
  "sales/upload-recording",
  async (payload, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${payload.token}`,
        },
      };

      const { data } = await instance.post(
        "/sales/portal/upload-recording",
        {
          tags: payload.tags,
          recording_url: payload.recording_url,
          repName: payload.repName,
          fileName: payload.fileName,
        },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getSalesRepData = createAsyncThunk(
  "sales/getSalesRepData",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const token = state.auth?.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await instance.post("/stats/portal/get-sales-rep",
        {
          name: payload?.name,
          year: payload?.year,
        },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);


export const updateRecordActivity = createAsyncThunk(
  "sales/updateRecordingActivity",
  async ({ recordingId, watchedSecs }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth?.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      };

      const body = { recording: recordingId };
      if (Number.isFinite(Number(watchedSecs)) && Number(watchedSecs) > 0) body.watchedSecs = Math.floor(Number(watchedSecs));
      const { data } = await instance.post("/sales/portal/update-recording-activity", body, config);
      return data;
    } catch (error) {
      console.error("Error updating recording activity:", error);
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const shareRecording = createAsyncThunk(
  "sales/shareRecording",
  async ({ recordingId, recipientRecIds, comment }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth?.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.post(
        `/sales/portal/share-recording/${recordingId}`,
        { recipientRecIds, comment },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const fetchRepSalesRecordings = createAsyncThunk(
  "sales/fetchRepSalesRecordings",
  async ({ employeeRecordId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth?.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      };

      const { data } = await instance.post(
        "/sales/portal/rep-sales-recordings", 
        { employeeRecordId }, 
        config
      );
      return data;
    } catch (error) {
      console.error("Error fetching rep sales recordings:", error);
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
